import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AuthImage from "@/components/AuthImage";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { AtSign, Users } from "lucide-react";

// Returns {query, start} when the caret sits in an "@word" token, else null
export function mentionToken(text, caret) {
  const before = text.slice(0, caret);
  const m = before.match(/(^|\s)@([\w.-]{0,30})$/);
  return m ? { query: m[2], start: before.length - m[2].length - 1 } : null;
}

// Renders message text with @Name tokens highlighted in gold
export function MentionText({ content, mentionNames = [], everyone }) {
  const names = [...mentionNames, ...(everyone ? ["everyone"] : [])].filter(Boolean).sort((a, b) => b.length - a.length);
  if (!names.length) return <>{content}</>;
  const re = new RegExp(`@(${names.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`, "g");
  const parts = []; let last = 0; let m;
  while ((m = re.exec(content))) { if (m.index > last) parts.push(content.slice(last, m.index)); parts.push(<span key={m.index} className="rounded bg-[hsl(var(--gold))]/20 px-1 font-700 text-[hsl(var(--gold))]" data-testid="mention-chip">@{m[1]}</span>); last = m.index + m[0].length; }
  if (last < content.length) parts.push(content.slice(last));
  return <>{parts}</>;
}

export default function MentionSuggest({ convId, token, onPick, activeIndex, onCount }) {
  const [list, setList] = useState({ members: [], everyone: false });
  useEffect(() => {
    if (!token) return;
    const t = setTimeout(() => api.get(`/island/conversations/${convId}/members`, { params: { q: token.query } }).then((r) => { setList(r.data); onCount((r.data.everyone ? 1 : 0) + r.data.members.length); }).catch(() => {}), 120);
    return () => clearTimeout(t);
  }, [convId, token?.query]); // eslint-disable-line
  if (!token) return null;
  const items = [...(list.everyone ? [{ id: "everyone", name: "everyone", position: "Ping every brother in this room" }] : []), ...list.members];
  if (!items.length) return null;
  return (
    <div className="glass absolute bottom-full left-0 z-30 mb-2 w-72 overflow-hidden rounded-xl border border-[hsl(var(--gold))]/30 shadow-xl" data-testid="mention-suggest">
      {items.map((m, i) => (
        <button key={m.id} onMouseDown={(e) => { e.preventDefault(); onPick(m); }} className={`flex w-full items-center gap-2.5 px-3 py-2 text-left text-sm ${i === activeIndex ? "bg-[hsl(var(--gold))]/15" : "hover:bg-secondary"}`} data-testid={`mention-option-${m.id}`}>
          <Avatar className="h-7 w-7">{m.id === "everyone" ? <AvatarFallback className="bg-[hsl(var(--gold))]/20 text-[hsl(var(--gold))]"><Users className="h-3.5 w-3.5" /></AvatarFallback> : m.photo_path ? <AuthImage path={m.photo_path} className="h-7 w-7 rounded-full object-cover" /> : <AvatarFallback className="text-[0.6rem]">{m.name?.[0]}</AvatarFallback>}</Avatar>
          <div className="min-w-0"><p className="truncate font-600"><AtSign className="mr-0.5 inline h-3 w-3 text-[hsl(var(--gold))]" />{m.name}</p><p className="truncate text-[0.65rem] text-muted-foreground">{m.position}{m.frigate ? ` · ${m.frigate}` : ""}</p></div>
        </button>
      ))}
    </div>
  );
}
